import { BaseReactiveClass } from 'Classes/BaseReactiveClass';

export class ModelAccountTrusteeItem extends BaseReactiveClass {
  constructor(data) {
    super(data);

    this.$set('$dataLoading', false);
  }

  get fullName() {
    return `${this.first_name} ${this.last_name}`;
  }
}
